import { ApiRoute } from "PFCore/utilities/routes";
import { Id, PermissionsGroup } from "PFTypes";

export const fetchPermissionsGroup = (id: Id): Promise<PermissionsGroup> =>
  //@ts-ignore
  $.ajax({
    url: ApiRoute(`/api/admin/permissions_groups/${id}`),
    api_version: 2
  });
